import { commonEndSimulation } from "../../../shared/common";
import { Multiplayer } from "../../../shared/constants";
import { GameState } from "../../../shared/game";
import { SyncMessageType } from "../../../shared/messageTypes";
import { ControlState, StateSystem } from "../../../shared/systems/stateSystem";
import { GameClient } from "../gameClient";
import { ClientRecapState } from "./clientRecapState";

export class ClientReconnectingState extends ControlState {
	isComplete = false;
	failed = false;
	private reconnectTimer: any = null;
	private stopped = false;

	constructor(private gameClient: GameClient, private hasConnection: boolean = false) {
		super();
	}

	getName(): GameState {
		return "reconnecting";
	}

	onEnter(_controller: StateSystem): void {
		commonEndSimulation(this.gameClient);
		this.gameClient.updateUI();
		if (!this.hasConnection) {
			this.startReconnectLoop();
		}
	}

	onCancel(): void {
		this.stopReconnectLoop();
	}

	onExit(controller: StateSystem): void {
		this.stopReconnectLoop();
		controller.pushState(new ClientRecapState(this.gameClient));
		this.gameClient.updateUI();
	}

	update(_delta: number): void {
		//Need to discard all messages that aren't GoToShop or PlayerSync since we are intentionally skipping simulation
		const messageBuffer = this.gameClient.messageBuffer!;
		if (messageBuffer.getFirstType() !== SyncMessageType.GotoShop && messageBuffer.getFirstType() !== SyncMessageType.PlayerSync) {
			messageBuffer.popFirstMessage();
		}
		const gotoShop = this.gameClient.messageBuffer?.dequeueMessage(SyncMessageType.GotoShop);
		if (gotoShop) {
			this.gameClient.latestVirusGrowth = gotoShop.virusGrowth || null;
			this.gameClient.round = gotoShop.newRoundNumber;
			this.isComplete = true;
		}
	}

	retry() {
		this.stopReconnectLoop();
		this.stopped = false;
		this.failed = false;
		this.gameClient.updateUI();
		this.startReconnectLoop();
	}

	private startReconnectLoop() {
		const connection = this.gameClient.connectionToServer;
		if (!connection || !connection.reconnect) return;
		let attempts = 0;

		const attempt = () => {
			if (this.stopped) return;
			++attempts;
			console.log('Attempting reconnect...');
			connection.reconnect().then(() => {
				console.log('Reconnected to server');
			}).catch(() => {
				if (this.stopped) return;
				if (attempts < Multiplayer.ClientReconnectMaxAttempts) {
					this.reconnectTimer = setTimeout(attempt, Multiplayer.ReconnectRetryDelay);
				}
				else {
					console.error('Failed to reconnect after maximum attempts');
					this.failed = true;
					this.gameClient.updateUI();
				}
			});
		};
		this.reconnectTimer = setTimeout(attempt, 1000);
	}

	private stopReconnectLoop() {
		this.stopped = true;
		if (this.reconnectTimer !== null) {
			clearTimeout(this.reconnectTimer);
			this.reconnectTimer = null;
		}
	}
}
